// Copyright ©️ 2025 eVolve MEP, LLC

import type { LabelTypeId } from '@evolvemep/api-ts';

import { WORK_ORDER_LABEL_TYPE_ID } from 'components/Mantine/Labels/constants';

const labelTypeIdToDeleteMessageMap: Record<LabelTypeId, string> = {
  [WORK_ORDER_LABEL_TYPE_ID]: 'This action will remove the label from existing work orders and cannot be undone.',
};

export const getDeleteLabelMessage = (labelTypeId: LabelTypeId): string | undefined =>
  labelTypeIdToDeleteMessageMap[labelTypeId];
